//demo 国际化
// import moment from 'moment'
import dayjs from 'dayjs'
import { demo_en, demo_zh, demo_cht, demo_tr, demo_ru, demo_th, demo_ar, demo_pt, demo_vie, demo_kor } from '../locales/demo_locale'
import {
  V2NIMMessage,
  V2NIMMessageFileAttachment,
} from 'nim-web-sdk-ng/dist/esm/nim/src/V2NIMMessageService'
const demoLocaleMap: any = {
  zh: demo_zh,
  en: demo_en,
  cht: demo_cht,
  tr: demo_tr,
  ru: demo_ru,
  th: demo_th,
  ara: demo_ar,
  pt: demo_pt,
  vie: demo_vie,
  kor: demo_kor
}

const languageType =
  (localStorage.getItem('lang') as "zh" | "en" | "ru" | "cht" | "tr" | "ara" | "pt" | "th" | "vie" | "fra" | "kor" | "fr") || 'zh'

//国际化
export const t = (str: keyof typeof demo_zh): string => {
  return demoLocaleMap[languageType][str]
}

/**
 * 秒转换为时分秒
 */
export const convertSecondsToTime = (seconds: number): string => {
  const hours: number = Math.floor(seconds / 3600)
  const minutes: number = Math.floor((seconds - hours * 3600) / 60)
  const remainingSeconds: number = seconds - hours * 3600 - minutes * 60

  let timeString = ''

  const includeHours = seconds >= 3600
  if (includeHours) {
    if (hours < 10) {
      timeString += '0'
    }
    timeString += hours.toString() + ':'
  }

  if (minutes < 10) {
    timeString += '0'
  }
  timeString += minutes.toString() + ':'

  if (remainingSeconds < 10) {
    timeString += '0'
  }
  timeString += remainingSeconds.toString()

  return timeString
}

//话单类型
export const g2StatusMap: any = {
  1: t('callDurationText'),
  2: t('callCancelText'),
  3: t('callRejectedText'),
  4: t('callTimeoutText'),
  5: t('callBusyText'),
}

export const callTypeMap = {
  audio: '1',
  vedio: '2',
}

export const groupBy = <T>(
  arr: T[],
  keys: {
    firstKey: string
    secondKey?: string
    thirdKey?: string
  },
  isLowerCase = true
): { key: string; data: T[] }[] => {
  const res: { [key: string]: T[] } = {}
  const OTHER_TAG = '#'

  const add = (k: string, v: T) => {
    const _k = isLowerCase ? k.toLowerCase() : k.toUpperCase()

    if (!res[_k]) {
      res[_k] = [v]
    } else {
      res[_k].push(v)
    }
  }

  arr.forEach((item: any) => {
    const v =
      item[keys.firstKey] ||
      item[keys.secondKey || ''] ||
      item[keys.thirdKey || '']

    if (!!v && typeof v === 'string') {
      const str = v[0]

      if (/^[a-zA-Z]$/.test(str)) {
        add(str.toLowerCase(), item)
      } else if (/^[\u4e00-\u9fa5]$/.test(str)) {
        const en = '*abcdefghjklmnopqrstwxyz'.split('')
        const zh = '阿八嚓哒妸发旮哈讥咔垃痳拏噢妑七呥扨它穵夕丫帀'.split('')
        const k = en.find(
          (k, ki) =>
            (!zh[ki - 1] || zh[ki - 1].localeCompare(str, 'zh') <= 0) &&
            str.localeCompare(zh[ki], 'zh') == -1
        )

        if (k && k !== '*') {
          add(k, item)
        } else {
          add(OTHER_TAG, item)
        }
      } else {
        add(OTHER_TAG, item)
      }
    } else {
      add(OTHER_TAG, item)
    }
  })

  const data = Object.keys(res).map((k) => ({ key: k, data: res[k] }))
  const sortData = data
    .filter((item) => item.key !== OTHER_TAG)
    .sort((a, b) => a.key.localeCompare(b.key, 'en'))
  const otherData = data.filter((item) => item.key === OTHER_TAG)

  return sortData.concat(otherData)
}
export const frequencyControl = <
  P extends string,
  R extends { account: string }
>(
  fn: (params: P[]) => Promise<R[]>,
  delay: number,
  limit: number
): ((params: P) => Promise<R>) => {
  const promiseQueue: { args: P; queue: { resolve: any; reject: any }[] }[] = []
  let requesting = false
  let timer: any

  return function (args) {
    return new Promise((resolve, reject) => {
      const p = promiseQueue.find((item) => item.args === args)

      if (p) {
        p.queue.push({ resolve, reject })
      } else {
        promiseQueue.push({ args, queue: [{ resolve, reject }] })
      }

      if (requesting) {
        return
      }

      const handler = (
        pq: { args: P; queue: { resolve: any; reject: any }[] }[]
      ) => {
        if (!pq.length) {
          return
        }

        requesting = true
        fn.call(
          // @ts-ignore
          this,
          pq.map((item) => item.args)
        )
          .then((res) => {
            while (pq.length) {
              const p = pq.shift()

              if (p) {
                const _ = res.find((j) => j.account === p.args)

                p.queue.forEach((j) => j.resolve(_))
              }
            }
          })
          .catch((err) => {
            while (pq.length) {
              const p = pq.shift()

              if (p) {
                p.queue.forEach((item) => item.reject(err))
              }
            }
          })
          .finally(() => {
            requesting = false
            if (promiseQueue.length) {
              handler(promiseQueue.splice(0, limit))
            }
          })
      }

      // 如果参数数量到达 limit，立即执行
      if (promiseQueue.length >= limit) {
        clearTimeout(timer)
        handler(promiseQueue.splice(0, limit))
      } else {
        clearTimeout(timer)
        timer = setTimeout(() => {
          handler(promiseQueue.splice(0, limit))
        }, delay)
      }
    })
  }
}
interface IKeyMap {
  [key: string]: string
}
export const EMOJI_ICON_MAP_CONFIG: IKeyMap = {
  '[大笑]': 'imicon-a-1',
  '[开心]': 'imicon-a-2',
  '[色]': 'imicon-a-3',
  '[酷]': 'imicon-a-4',
  '[奸笑]': 'imicon-a-5',
  '[亲]': 'imicon-a-6',
  '[伸舌头]': 'imicon-a-7',
  '[眯眼]': 'imicon-a-8',
  '[可爱]': 'imicon-a-9',
  '[鬼脸]': 'imicon-a-10',
  '[偷笑]': 'imicon-a-11',
  '[喜悦]': 'imicon-a-12',
  '[狂喜]': 'imicon-a-13',
  '[惊讶]': 'imicon-a-14',
  '[流泪]': 'imicon-a-15',
  '[流汗]': 'imicon-a-16',
  '[天使]': 'imicon-a-17',
  '[笑哭]': 'imicon-a-18',
  '[尴尬]': 'imicon-a-19',
  '[惊恐]': 'imicon-a-20',
  '[大哭]': 'imicon-a-21',
  '[烦躁]': 'imicon-a-22',
  '[恐怖]': 'imicon-a-23',
  '[两眼冒星]': 'imicon-a-24',
  '[害羞]': 'imicon-a-25',
  '[睡着]': 'imicon-a-26',
  '[冒星]': 'imicon-a-27',
  '[口罩]': 'imicon-a-28',
  '[OK]': 'imicon-a-29',
  '[好吧]': 'imicon-a-30',
  '[鄙视]': 'imicon-a-31',
  '[难受]': 'imicon-a-32',
  '[不屑]': 'imicon-a-33',
  '[不舒服]': 'imicon-a-34',
  '[愤怒]': 'imicon-a-35',
  '[鬼怪]': 'imicon-a-36',
  '[发怒]': 'imicon-a-37',
  '[生气]': 'imicon-a-38',
  '[不高兴]': 'imicon-a-39',
  '[皱眉]': 'imicon-a-40',
  '[心碎]': 'imicon-a-41',
  '[心动]': 'imicon-a-42',
  '[好的]': 'imicon-a-43',
  '[低级]': 'imicon-a-44',
  '[赞]': 'imicon-a-45',
  '[鼓掌]': 'imicon-a-46',
  '[给力]': 'imicon-a-47',
  '[打你]': 'imicon-a-48',
  '[阿弥陀佛]': 'imicon-a-49',
  '[拜拜]': 'imicon-a-50',
  '[第一]': 'imicon-a-51',
  '[拳头]': 'imicon-a-52',
  '[手掌]': 'imicon-a-53',
  '[剪刀]': 'imicon-a-54',
  '[招手]': 'imicon-a-55',
  '[不要]': 'imicon-a-56',
  '[举着]': 'imicon-a-57',
  '[思考]': 'imicon-a-58',
  '[猪头]': 'imicon-a-59',
  '[不听]': 'imicon-a-60',
  '[不看]': 'imicon-a-61',
  '[不说]': 'imicon-a-62',
  '[猴子]': 'imicon-a-63',
  '[炸弹]': 'imicon-a-64',
  '[睡觉]': 'imicon-a-65',
  '[筋斗云]': 'imicon-a-66',
  '[火箭]': 'imicon-a-67',
  '[救护车]': 'imicon-a-68',
  '[便便]': 'imicon-a-70',
}
export const emojiTranslate = (t) => {
  const SHOW_EMOJI_ICON_MAP_CONFIG: IKeyMap = {
    [t('Laugh')]: 'imicon-a-1',
    [t('Happy')]: 'imicon-a-2',
    [t('Sexy')]: 'imicon-a-3',
    [t('Cool')]: 'imicon-a-4',
    [t('Mischievous')]: 'imicon-a-5',
    [t('Kiss')]: 'imicon-a-6',
    [t('Spit')]: 'imicon-a-7',
    [t('Squint')]: 'imicon-a-8',
    [t('Cute')]: 'imicon-a-9',
    [t('Grimace')]: 'imicon-a-10',
    [t('Snicker')]: 'imicon-a-11',
    [t('Joy')]: 'imicon-a-12',
    [t('Ecstasy')]: 'imicon-a-13',
    [t('Surprise')]: 'imicon-a-14',
    [t('Tears')]: 'imicon-a-15',
    [t('Sweat')]: 'imicon-a-16',
    [t('Angle')]: 'imicon-a-17',
    [t('Funny')]: 'imicon-a-18',
    [t('Awkward')]: 'imicon-a-19',
    [t('Thrill')]: 'imicon-a-20',
    [t('Cry')]: 'imicon-a-21',
    [t('Fretting')]: 'imicon-a-22',
    [t('Terrorist')]: 'imicon-a-23',
    [t('Halo')]: 'imicon-a-24',
    [t('Shame')]: 'imicon-a-25',
    [t('Sleep')]: 'imicon-a-26',
    [t('Tired')]: 'imicon-a-27',
    [t('Mask')]: 'imicon-a-28',
    [t('ok')]: 'imicon-a-29',
    [t('AllRight')]: 'imicon-a-30',
    [t('Despise')]: 'imicon-a-31',
    [t('Uncomfortable')]: 'imicon-a-32',
    [t('Disdain')]: 'imicon-a-33',
    [t('ill')]: 'imicon-a-34',
    [t('Mad')]: 'imicon-a-35',
    [t('Ghost')]: 'imicon-a-36',
    [t('huff')]: 'imicon-a-37',
    [t('Angry')]: 'imicon-a-38',
    [t('Unhappy')]: 'imicon-a-39',
    [t('Frown')]: 'imicon-a-40',
    [t('Broken')]: 'imicon-a-41',
    [t('Beckoning')]: 'imicon-a-42',
    [t('Ok')]: 'imicon-a-43',
    [t('Low')]: 'imicon-a-44',
    [t('Nice')]: 'imicon-a-45',
    [t('Applause')]: 'imicon-a-46',
    [t('GoodJob')]: 'imicon-a-47',
    [t('Hit')]: 'imicon-a-48',
    [t('Please')]: 'imicon-a-49',
    [t('Bye')]: 'imicon-a-50',
    [t('First')]: 'imicon-a-51',
    [t('Fist')]: 'imicon-a-52',
    [t('GiveMeFive')]: 'imicon-a-53',
    [t('Knife')]: 'imicon-a-54',
    [t('Hi')]: 'imicon-a-55',
    [t('No')]: 'imicon-a-56',
    [t('Hold')]: 'imicon-a-57',
    [t('Think')]: 'imicon-a-58',
    [t('Pig')]: 'imicon-a-59',
    [t('NoListen')]: 'imicon-a-60',
    [t('NoLook')]: 'imicon-a-61',
    [t('NoWords')]: 'imicon-a-62',
    [t('Monkey')]: 'imicon-a-63',
    [t('Bomb')]: 'imicon-a-64',
    [t('Sleeping')]: 'imicon-a-65',
    [t('Cloud')]: 'imicon-a-66',
    [t('Rocket')]: 'imicon-a-67',
    [t('Ambulance')]: 'imicon-a-68',
    [t('Poop')]: 'imicon-a-70',
  }

  const INPUT_EMOJI_SYMBOL_REG = new RegExp(
    '(' +
      Object.keys(EMOJI_ICON_MAP_CONFIG)
        .map((item) => {
          const left = `\\${item.slice(0, 1)}`
          const right = `\\${item.slice(-1)}`
          const mid = item.slice(1, -1)

          return `${left}${mid}${right}`
        })
        .join('|') +
      ')',
    'g'
  )

  return {
    SHOW_EMOJI_ICON_MAP_CONFIG,
    INPUT_EMOJI_SYMBOL_REG,
  }
}

export function replaceEmoji(text: string, emojiMap?: string[]) {
  const emojiMapConfig = emojiMap || {
    '[Laugh]': '[大笑]',
    '[Happy]': '[开心]',
    '[Sexy]': '[色]',
    '[Cool]': '[酷]',
    '[Mischievous]': '[奸笑]',
    '[Kiss]': '[亲]',
    '[Spit]': '[伸舌头]',
    '[Squint]': '[眯眼]',
    '[Cute]': '[可爱]',
    '[Grimace]': '[鬼脸]',
    '[Snicker]': '[偷笑]',
    '[Joy]': '[喜悦]',
    '[Ecstasy]': '[狂喜]',
    '[Surprise]': '[惊讶]',
    '[Tears]': '[流泪]',
    '[Sweat]': '[流汗]',
    '[Angle]': '[天使]',
    '[Funny]': '[笑哭]',
    '[Awkward]': '[尴尬]',
    '[Thrill]': '[惊恐]',
    '[Cry]': '[大哭]',
    '[Fretting]': '[烦躁]',
    '[Terrorist]': '[恐怖]',
    '[Halo]': '[两眼冒星]',
    '[Shame]': '[害羞]',
    '[Sleep]': '[睡着]',
    '[Tired]': '[睡觉]',
    '[Mask]': '[口罩]',
    '[Ok]': '[OK]',
    '[All right]': '[好吧]',
    '[Despise]': '[鄙视]',
    '[Uncomfortable]': '[难受]',
    '[Disdain]': '[不屑]',
    '[ill]': '[不舒服]',
    '[Mad]': '[愤怒]',
    '[Ghost]': '[鬼怪]',
    '[Huff]': '[发怒]',
    '[Angry]': '[生气]',
    '[Unhappy]': '[不高兴]',
    '[Frown]': '[皱眉]',
    '[Broken]': '[心碎]',
    '[Beckoning]': '[心动]',
    '[Low]': '[低级]',
    '[Nice]': '[赞]',
    '[Applause]': '[鼓掌]',
    '[Good job]': '[给力]',
    '[Hit]': '[打你]',
    '[Please]': '[阿弥陀佛]',
    '[Bye]': '[拜拜]',
    '[First]': '[第一]',
    '[Fist]': '[拳头]',
    '[Give me five]': '[招手]',
    '[Knife]': '[剪刀]',
    '[Hi]': '[招手]',
    '[No]': '[不要]',
    '[Hold]': '[举着]',
    '[Think]': '[思考]',
    '[Pig]': '[猪头]',
    '[No listen]': '[不听]',
    '[No look]': '[不看]',
    '[No words]': '[不说]',
    '[Monkey]': '[猴子]',
    '[Bomb]': '[炸弹]',
    '[Sleeping]': '[睡觉]',
    '[Cloud]': '[筋斗云]',
    '[Rocket]': '[火箭]',
    '[Ambulance]': '[救护车]',
    '[Poop]': '[便便]',
  }
  const emojiMapRegex = new RegExp(
    '(' +
      Object.keys(emojiMapConfig)
        .map((item) => {
          const left = `\\${item.slice(0, 1)}`
          const right = `\\${item.slice(-1)}`
          const mid = item.slice(1, -1)

          return `${left}${mid}${right}`
        })
        .join('|') +
      ')',
    'g'
  )

  return text.replace(emojiMapRegex, function (matched) {
    return emojiMapConfig[matched]
  })
}

export function getImgDataUrl(file: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = (e) => {
      resolve(e.target?.result as string)
    }

    reader.onerror = (e) => {
      reject(e)
    }

    reader.readAsDataURL(file)
  })
}
export function getVideoFirstFrameDataUrl(videoFile: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video')
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')

    video.onloadeddata = () => {
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      context?.drawImage(video, 0, 0, canvas.width, canvas.height)
      const dataURL = canvas.toDataURL('image/jpeg')

      resolve(dataURL)
    }

    video.onerror = () => {
      reject(new Error('Failed to load the video'))
    }

    const url = URL.createObjectURL(videoFile)

    video.preload = 'auto'
    video.autoplay = true
    video.muted = true
    video.src = url
  })
}
export const formatDate = (time: number): string => {
  // const date = moment(time)
  // const isCurrentDay = date.isSame(moment(), 'day')
  // const isCurrentYear = date.isSame(moment(), 'year')
  const date = dayjs(time)
  const isCurrentDay = date.isSame(dayjs(), 'day')
  const isCurrentYear = date.isSame(dayjs(), 'year')

  return isCurrentDay
    ? date.format('HH:mm:ss')
    : isCurrentYear
    ? date.format('MM-DD HH:mm:ss')
    : date.format('YYYY-MM-DD HH:mm:ss')
}
export const renderMsgDate = (time: any) => {
  // const date = moment(time)
  // const isCurrentDay = date.isSame(moment(), 'day')
  // const isCurrentYear = date.isSame(moment(), 'year')
  const date = dayjs(time)
  const isCurrentDay = date.isSame(dayjs(), 'day')
  const isCurrentYear = date.isSame(dayjs(), 'year')
  return isCurrentDay
    ? date.format('HH:mm:ss')
    : isCurrentYear
    ? date.format('MM-DD HH:mm:ss')
    : date.format('YYYY-MM-DD HH:mm:ss')
}
export const hasQueryParams = (url: string): boolean => {
  try {
    const parsedUrl = new URL(url)

    return parsedUrl.search !== ''
  } catch (error) {
    return false
  }
}

export const getDownloadUrl = (msg: V2NIMMessage) => {
  // todo 这个定义难过
  const attachment = msg.attachment as V2NIMMessageFileAttachment

  return hasQueryParams(attachment.url)
    ? `${attachment.url}&download=${msg.messageClientId}${attachment.ext}`
    : `${attachment.url}?download=${msg.messageClientId}${attachment.ext}`
}
export const getAIErrorMap = (t): { [key: number]: string } => {
  return {
    102404: t('memberNotExistsText'),
    189308: t('tipAIFailedMessageText'),
    189451: t('aiAntiSpamText'),
    107337: t('aiFunctionDisabled'),
    102422: t('aiMemberBanned'),
    102421: t('aiMemberChatBanned'),
    104404: t('aiFriendNotExists'),
    107451: t('aiMessageHitAntiSpam'),
    102304: t('notAnAi'),
    109404: t('aiTeamMemberNotExists'),
    108306: t('aiNormalTeamChatBanned'),
    109424: t('aiTeamChatBanned'),
    106403: t('aiBlockFailedText'),
    416: t('aiRateLimit'),
    414: t('aiParameterError'),
    107336: t('tipAIMessageText'),
  }
}

// 当用户或者群聊没有头像时，用于根据account生成头像背景色
export const getAvatarBackgroundColor = (account: any): string => {
  const colorMap: { [key: number]: string } = {
    0: '#60CFA7',
    1: '#53C3F3',
    2: '#537FF4',
    3: '#854FE2',
    4: '#BE65D9',
    5: '#E9749D',
    6: '#F9B751',
  }
  // 将account转换为数字，取余数作为头像颜色索引
  const stringToNumber = (inputString: string) => {
    let hash = 0

    if (inputString.length === 0) {
      return hash
    }

    for (let i = 0; i < inputString.length; i++) {
      const char = inputString.charCodeAt(i)

      hash = (hash << 5) - hash + char // 简单的加权算法
      hash = hash & hash // 将 hash 转换为 32 位整数
    }

    return Math.abs(hash) // 返回绝对值，确保为正数
  }

  const bgColorIndex = (stringToNumber(account) || 0) % 7

  return colorMap[bgColorIndex]
}
/**
 * 解析 sessionId，形如 scene-accid
 */
export const parseSessionId = (
  sessionId: string
): { scene: string; to: string } => {
  const [scene, ...to] = sessionId.split('-')
  return {
    scene,
    // 这样处理是为了防止有些用户 accid 中自带 -
    to: to.join('-'),
  }
}